import SecureRequest from "../utils/securerequest";

export const getProcessStatus = async (invocationId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const url = `/v3/process/${invocationId}/status`;
  const response = await Request.get(url);
  return response;
};

export const getProcessResult = async (invocationId, targetProcess) => {
  const secureRequest = new SecureRequest();
  const request = secureRequest.getRequest();
  //if "bulk_download" then modify the request to recieve blob
  if (targetProcess === "bulk_download") {
    const response = await request.get(`/v3/process/${invocationId}/result`, {
      responseType: "blob",
      headers: {
        Accept: "application/zip, application/octet-stream",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    return {
      data: response.data,
    };
  } else {
    const response = await request.get(`/v3/process/${invocationId}/result`);
    return {
      response,
    };
  }
};

export const generateProcess = async (processData) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const url = `/v3/process/generate`;
  const response = await Request.post(url, processData);
  return response;
};
